import React from 'react';

const QADashboardPage = () => {
  return (
    <div>
      <h1>QA Dashboard</h1>
    </div>
  );
};

export default QADashboardPage;
